export default class GBRGVKServices {

    log(value) {
        console.log(value);
    }

}